import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector   : 'mo-lemken-percentage',
    templateUrl: './mo-lemken-percentage.component.html',
    styleUrls  : ['./mo-lemken-percentage.component.scss']
})
export class MoLemkenPercentageComponent implements OnInit {
    /**
     * The Percentage.
     */
    private _percentage: number;
    /**
     * Class to apply
     */
    private _classPercentage: string = 'text-black';

    constructor() {
    }

    ngOnInit() {
    }

    /**
     * Getter.
     */
    @Input()
    public get percentage(): number {
        return this._percentage;
    }

    /**
     * Setter.
     * @param value
     */
    public set percentage(value: number) {
        this._percentage = value;
        if (this._percentage > 70) {
            this._classPercentage = 'text-lemken';
        } else {
            if (this._percentage > 40) {
                this._classPercentage = 'text-warning';
            } else {
                this._classPercentage = 'text-danger';
            }
        }
    }

    /**
     * Getter Class
     */
    public get classPercentage(): string {
        return this._classPercentage;
    }
}
